import React, { ReactNode } from 'react';

import { IComponent } from '../../../typings/generic-component';
import './tooltip.scss';
import { makeClassNames } from '../../../utils/styles';

export interface ITooltip extends IComponent {
  text: ReactNode;
}

const classNames = (className: string) =>
  makeClassNames({
    tooltip: `tooltip ${className}`,
    tooltipText: 'tooltip__text',
  });

const Tooltip = ({ children, text, className = '' }: ITooltip) => {
  const cn = classNames(className);

  return (
    <span className={cn.tooltip}>
      <span className={cn.tooltipText}>{text}</span>
      {children}
    </span>
  );
};

export default Tooltip;
